//alert(1);
// $(document).ready(function(){
//   $("button").click(function(){
//     $("p").hide();
//   });
// });

/* ------------------------------------------------------------ */
/* ---- Start product code added by AL.. for Group products ---- */
/* ------------------------------------------------------------ */ 

$(document).ready(function(){
 setTimeout(function () {  
 // var text = $('p.gp-slide0-val').html(); 
 //remove(text); 
  $( "p.gp-slide0-val" ).empty();
  $( "p.gp-slide1-val" ).empty();
  // $( "p.gp-slide2-val" ).empty();
 if($('.gp-grid').hasClass('selected')){
   $('.gp-grid').removeClass('selected');
 }
   }, 500); 
});

var $currSlide,$currBody;
function repositionGpBtns () {
  $currSlide = $('.gp-slide:eq('+$('.gp-slide-wrap').attr('current-slide')+')');
  if($currSlide.length) {
    $currBody = $currSlide.find('.gp-slide-body');

    if($currSlide.outerHeight() > ($currBody.outerHeight()+$currBody.position().top)) {
      $('.gp-buttons.btm-btns').css('top',0-($currSlide.outerHeight()-($currBody.outerHeight()+$currBody.position().top)));
    }
    else {
      $('.gp-buttons.btm-btns').css('top',0);
    }
  }
} 

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
var selection = [];
function saveSelection() {
  selection = [];
  $('.gp-grid.selected').each(function(index){
    selection.push($(this).attr('data-id'));
  });
  setCookie('kl_group_selection',JSON.stringify(selection),1);
}

function checkSelection(slideno) {
  if($('.gp-slide:eq('+slideno+')').hasClass('required')) {
    if($('.gp-slide:eq('+slideno+') .selected').length) {
      $('.gp-buttons .btn-next').attr('disabled', false);
    }  
    else {
      $('.gp-buttons .btn-next').attr('disabled', true);
    }
  }
  else {
    $('.gp-buttons .btn-next').attr('disabled', false);
  }
}  


function bulkAdd(products) {
  if(products.length) {
    var product_id = products.shift();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: {
        id: product_id,
        quantity: 1
      },
      success: function() {
        bulkAdd(products);
      }
    })
  }
  else {
    $('.gp-buttons .btn-gp-add').removeClass('btn-processing').attr('disabled', false);
    location.href = '/cart';
    $.cookie('kl_group_selection', null);
  }
}

/* CD - group product selection */
var transitionTime,headerOffset = 0;
if($('header.util').length) {
  headerOffset = $('header.util').outerHeight()+20;
}
$(document).ready(function(){
$('.gp-buttons .btn-prev').on('click', function(){
  var prevSlide = parseInt($('.gp-slide-wrap').attr('current-slide'))-1;
  $('.gp-slide-wrap').attr('current-slide',prevSlide);
  $('.top-bar .txt-step-no').text($('.gp-slide:eq('+prevSlide+')').attr('step-no'));
  $('.top-bar .txt-step-info').text($('.gp-slide:eq('+prevSlide+')').attr('step-info'));
  $('.gp-buttons .btn-next').show();
  $('.gp-buttons .btn-gp-add').addClass('hide');
  if(prevSlide <= 0) {
    $('.gp-buttons .btn-prev').attr('disabled', true);
  }
//   transitionTime = setTimeout(function(){
//     $('html, body').animate({scrollTop: $('.grup-prdcts-i').offset().top-headerOffset});
//   },310);
  checkSelection(prevSlide);
  repositionGpBtns();
});

$('.gp-buttons .btn-next').on('click', function(){
  var nextSlide = parseInt($('.gp-slide-wrap').attr('current-slide'))+1;
  var totalSlides = parseInt($('.gp-slide-wrap').attr('total-slides'))-1;
  $('.gp-slide-wrap').attr('current-slide',nextSlide);
  $('.top-bar .txt-step-no').text($('.gp-slide:eq('+nextSlide+')').attr('step-no'));
  $('.top-bar .txt-step-info').text($('.gp-slide:eq('+nextSlide+')').attr('step-info'));
  $('.gp-buttons .btn-prev').attr('disabled', false);
  if(nextSlide >= totalSlides) {
    $('.gp-buttons .btn-next').hide();
    $('.gp-buttons .btn-gp-add').removeClass('hide');
  }
  clearTimeout(transitionTime);
//   transitionTime = setTimeout(function(){
//     $('html, body').animate({scrollTop: $('.grup-prdcts-i').offset().top-headerOffset});
//   },310);
  checkSelection(nextSlide);
  saveSelection();
  repositionGpBtns();
});
});
var selected_arr = [],selected_price_arr = [],selected_sku_arr = [],selected_str;
//alert(selected_arr.length);



// COLLECTION SWATCH
$(document).ready(function(){
$('.gp-grid-1').on('click', function(){
 // alert(1);
  selected_arr = [];
  selected_price_arr = [];
  selected_sku_arr = [];
  selected_variant_id_arr = [];
  
  if($(this).hasClass('gp-grid-disabled')) return;
  if($(this).hasClass('type-rad')) {
    $(this).addClass('selected');
    $(this).siblings().removeClass('selected');
  }
  else if($(this).hasClass('type-chk')) {
    $(this).toggleClass('selected');
  }
  
  if($(this).parents('.gp-slide').hasClass('required')) {
    if($(this).parents('.gp-slide-1').find('.selected').length) {
      $('.gp-buttons .btn-next').attr('disabled', false);
    }
    else {
      $('.gp-buttons .btn-next').attr('disabled', true);
    }
  }

  $(this).parents('.gp-slide-1').find('.selected').each(function(){
    selected_arr.push($(this).find('.gp-grid-title').text().trim());
    selected_price_arr.push($(this).find('.gp-grid-price').text().trim());
    selected_sku_arr.push($(this).find('.gp-grid-sku').text().trim());
    selected_variant_id_arr.push($(this).attr("data-id").trim());
  });
  
  if(selected_arr.length) {
    selected_str = selected_arr.join(',<br/>');
    //alert(selected_str);
          $(".grup-prdcts-summary-info1").empty();
          $(".group-prdcts-summary-variant-info").empty();
    
          //$(".grup-prdcts-summary-info1").append('Polyster : ');
          $(".group-prdcts-summary-variant-info").append('https://softframe.myshopify.com/cart/');


          var total_item_size = selected_price_arr.length;
    
          $.each(selected_price_arr, function (key, val) {
                //alert(selected_arr[key] + val);
              var get_index_item = key + 1;
              $(".grup-prdcts-summary-info1").append(get_index_item+') '+selected_arr[key] +' - '+ selected_sku_arr[key] +' - '+val+' - '+selected_variant_id_arr[key]+", ");
              //$(".group-prdcts-summary-variant-info").append(selected_variant_id_arr[key]+":1,");
              if (key === total_item_size - 1) {
                $(".group-prdcts-summary-variant-info").append(selected_variant_id_arr[key]+':1');
              }else{
                $(".group-prdcts-summary-variant-info").append(selected_variant_id_arr[key]+':1,');
              }
          });
    
   // $('.gp-slide0-val').text(selected_str);
    $('.gp-slide0-val').html('<span>'+ selected_str + '</span>');
  }
  else {
    $('.gp-slide0-val').text('');
    $('.product_count span').text('0');
  }

  
  // Product Count
  var numItems =  $('.gp-grid-1.selected').length;
  //alert(numItems);
  if(numItems > 0){  
    $('.gp-slide0-label').show();
    //$('.gp-grid').addClass('gp-grid-disabled');
    //$("*").find('div.gp-grid-1').not(".selected,.gp-grid-disabled").addClass('deselect');
    //$('.btn-gp-add').removeClass('deselect');
  }
  else{    
  $('.gp-slide0-label').hide();  
  $('.gp-grid-1').removeClass('deselect');
  //$('.btn-gp-add').addClass('deselect');  
  }
  // Product Count

  
  if ($('.gp-slide0-val').is(':empty') && $('.gp-slide1-val').is(':empty') ) { 
    $('.gp-when-empty').show(); 
    $('.btn-gp-add').addClass('deselect'); 
    $('.order-swatches-button').addClass('deselect'); 
  }
  else{
    $('.gp-when-empty').hide(); 
    $('.btn-gp-add').removeClass('deselect'); 
    $('.order-swatches-button').removeClass('deselect'); 
  }
});


$('.gp-grid-2').on('click', function(){
 // alert(1);
  selected_arr = [];
  selected_price_arr = [];
  selected_sku_arr = [];
  
  if($(this).hasClass('gp-grid-disabled')) return;
  if($(this).hasClass('type-rad')) {
    $(this).addClass('selected');
    $(this).siblings().removeClass('selected');
  }
  else if($(this).hasClass('type-chk')) {
    $(this).toggleClass('selected');
  }
  
  if($(this).parents('.gp-slide').hasClass('required')) {
    if($(this).parents('.gp-slide-1').find('.selected').length) {
      $('.gp-buttons .btn-next').attr('disabled', false);
    }
    else {
      $('.gp-buttons .btn-next').attr('disabled', true);
    }
  }


  $(this).parents('.gp-slide-2').find('.selected').each(function(){
    selected_arr.push($(this).find('.gp-grid-title').text().trim());
    selected_price_arr.push($(this).find('.gp-grid-price').text().trim());
    selected_sku_arr.push($(this).find('.gp-grid-sku').text().trim());
  });
  
  if(selected_arr.length) {
    selected_str = selected_arr.join(',<br/>');
    $('.gp-slide1-val').html('<span>'+ selected_str + '</span>');
   
          $(".grup-prdcts-summary-info2").empty();
    
          //$(".grup-prdcts-summary-info2").append('Poly-linen blend: ');
          $.each(selected_price_arr, function (key, val) {
                //alert(selected_arr[key] + val);
              var get_index_item = key + 1;
              $(".grup-prdcts-summary-info2").append(get_index_item+') '+selected_arr[key] +' - '+ selected_sku_arr[key] +' - '+val+", ");
          });    
  }
  else {
    $('.gp-slide1-val').text('');
    $('.product_count span').text('0');
  }
  
  // Product Count
  var numItems =  $('.gp-grid-2.selected').length;
  //alert(numItems);
  if(numItems > 0){  
    $('.gp-slide1-label').show();
    //$('.gp-grid').addClass('gp-grid-disabled');
    //$("*").find('div.gp-grid-2').not(".selected,.gp-grid-disabled").addClass('deselect');
    //$('.btn-gp-add').removeClass('deselect');
  }
  else{    
  $('.gp-slide1-label').hide();  
  $('.gp-grid-2').removeClass('deselect');
  //$('.btn-gp-add').addClass('deselect');  
  }
  // Product Count
  if ($('.gp-slide0-val').is(':empty') && $('.gp-slide1-val').is(':empty') ) { 
    $('.gp-when-empty').show(); 
    $('.btn-gp-add').addClass('deselect'); 
    $('.order-swatches-button').addClass('deselect'); 
  }
  else{
    $('.gp-when-empty').hide(); 
    $('.btn-gp-add').removeClass('deselect'); 
    $('.order-swatches-button').removeClass('deselect'); 
    
  }
  
});  
});
// COLLECTION SWATCH





$(document).ready(function(){
$('.gp-buttons .btn-gp-add').on('click', function(){
  var products = [];
  saveSelection();
  if(getCookie('kl_group_selection') != '') {
    products = JSON.parse(getCookie('kl_group_selection'));
    if(products.length) {
      $('.gp-buttons .btn-gp-add').addClass('btn-processing').attr('disabled',true)
      products.reverse();
      bulkAdd(products);
    }
  
  }
   
});
});

/* Reposition buttons based on slide height */
$(window).on('load',function(){
  if($('.gp-buttons').length) {
    repositionGpBtns();
    $('.btm-btns').show();
  }
});
$(document).ready(function(){
  var selectedArr,indexNo,tempArr = [];
  
  if(getCookie('kl_group_selection') != '') {
    selectedArr = JSON.parse(getCookie('kl_group_selection'));
    $.each(selectedArr,function(index, value){
      tempArr = [];
      $('.gp-grid[data-id="'+value+'"]').addClass('selected');
      indexNo = $('.gp-grid[data-id="'+value+'"]').parents('.gp-slide').index();
      if($('.gp-slide'+indexNo+'-val').text().trim() != '') {
        tempArr = $('.gp-slide'+indexNo+'-val').text().trim().split(',');
      }
      tempArr.push($('.gp-grid[data-id="'+value+'"]').find('.gp-grid-title').text().trim());

      $('.gp-slide'+indexNo+'-val').text(tempArr.join(','));
    });
    
    if($('.gp-slide-1').hasClass('required')) {
      if($('.gp-slide-1 .gp-grid.selected').length) {
        $('.gp-buttons .btn-next').attr('disabled',false);
      }
      else {
        $('.gp-buttons .btn-next').attr('disabled',true);
      }
    }
  }
});

$(document).ready(function(){
$('.gp-summary-i h3').on('click', function(){
  if($(window).width() <= 800 ) {
    $(this).toggleClass('active');
    $('.gp-summary-content').slideToggle();
  }
});
});  
/* ------------------------------------------------------------ */
/* ---- End product code added by AL.. for Group products ---- */
/* ------------------------------------------------------------ */

$(document).ready(function() {
  
  $('body').on('click', '.qorder-swatches-button,.qform-dialog-close-button', function() {
      $("body").toggleClass("active-order-swatches-popup");    
  });

  $('body').on('click', '.order-swatches-button', function() {
      //$("body").toggleClass("active-order-swatches-popup");        
    var get_order_link = $(".group-prdcts-summary-variant-info").text();
   // alert("jdfk"+get_order_link);    
    location.href = get_order_link;
  });  
  
});


// $(document).ready(function(){
// $(window).scroll(function () {   
   
//  if($(window).scrollTop() > 500) {
//     $('#sidebar').css('position','fixed');
//     $('#sidebar').css('top','100px'); 
//    $('body').addClass('sticky-bundle-summary');
//  }

//  else if ($(window).scrollTop() <= 500) {
//     $('#sidebar').css('position','');
//     $('#sidebar').css('top','');
//    $('body').addClass('sticky-bundle-summary');
//  }  
//     if ($('#sidebar').offset().top + $("#sidebar").height() > $("#shopify-section-footer").offset().top) {
//         $('#sidebar').css('top',-($("#sidebar").offset().top + $("#sidebar").height() - $("#shopify-section-footer").offset().top));
//     }
// });
// });


// $(function() {
//     // Cache our vars for the fixed sidebar on scroll
//     var $sidebar = $('#sidebar');
//     // Get & Store the original top of our #sidebar-nav so we can test against it
//     var sidebarTop = $sidebar.position().top;
//     // Edit the `- 10` to control when it should disappear when the footer is hit.
//     var blogHeight = $('#content').outerHeight() - 10;

//     // Add the function below to the scroll event
//     $(window).scroll(fixSidebarOnScroll);

//     // On window scroll, this fn is called (binded above)
//     function fixSidebarOnScroll() {
//         // Cache our scroll top position (our current scroll position)
//         var windowScrollTop = $(window).scrollTop();

//         // Add or remove our sticky class on these conditions
//         if (windowScrollTop >= blogHeight || windowScrollTop <= sidebarTop) {
//             // Remove when the scroll is greater than our #content.OuterHeight()
//             // or when our sticky scroll is above the original position of the sidebar
//             $sidebar.removeClass('fixed');
//         }
//         // Scroll is past the original position of sidebar
//         else if (windowScrollTop >= sidebarTop) {
//             // Otherwise add the sticky if $sidebar doesnt have it already!
//             if (!$sidebar.hasClass('fixed')) {
//                 $sidebar.addClass('fixed');
//             }
//         }
//     }
// });


  
  //var script_url = "https://script.google.com/macros/s/AKfycbytlZvCwcj1wf1aCfG91ljv26vOSlZ8Yp_My8w4w7QZAWUbCFmnR6m_rza_ivglwfUK-Q/exec";  
  //var script_url = "https://script.google.com/macros/s/AKfycbxpfyCzcv-jGSgjgnVxaj-YkOCF7unPB8LTNDfYyMWFx3vpV5aeBoTHfOXyjA2dJIo7/exec";  
  var script_url = "https://script.google.com/macros/s/AKfycbxTnp1WTS7m54lplwL4NhHQns0ZAbtmL6lKQd0yONzsbvR8D7rzZGO0xRpFfDRRrDt4/exec";  

  
  
  // Make an AJAX call to Google Script

  // print the returned data
  function ctrlq(e) {
  
	
	$("#re").html(e.result);
	$("#re").css("visibility","visible"); 
  //$(".downvote-message").slideUp();   
   document.getElementById("loader").style.visibility = "hidden";
   document.getElementById("loader").style.display = "none";    				
   location.reload();
	//read_value();
	
  }
  

function read_value() {

$("#re").css("visibility","hidden");
   
   document.getElementById("loader").style.visibility = "visible";
 var url = script_url+"?action=read";

$.getJSON(url, function (json) {

    // Set the variables from the results array
   
   console.log(json);
  

        // CREATE DYNAMIC TABLE.
        var table = document.createElement("table");

		

        var header = table.createTHead();
		var row = header.insertRow(0);     
		var cell1 = row.insertCell(0);
		var cell2 = row.insertCell(1);
	
		cell1.innerHTML = "<b>ID</b>";
		cell2.innerHTML = "<b>Name</b>";
        
        // ADD JSON DATA TO THE TABLE AS ROWS.
        for (var i = 0; i < json.records.length; i++) {

            tr = table.insertRow(-1);
				var tabCell = tr.insertCell(-1);
                tabCell.innerHTML = json.records[i].ID;
				tabCell = tr.insertCell(-1);
				tabCell.innerHTML = json.records[i].NAME;
            }
      

        // FINALLY ADD THE NEWLY CREATED TABLE WITH JSON DATA TO A CONTAINER.
        var divContainer = document.getElementById("showData");
        divContainer.innerHTML = "";
        divContainer.appendChild(table);
		document.getElementById("loader").style.visibility = "hidden";
		$("#re").css("visibility","visible");
    });
	}

$(document).ready(function() {

  
  $('body').on('submit', 'form.form_div', function() {
    //alert("place");

        var order_firstName = $('[name="firstName"]').val();
        var order_lastName = $('[name="lastName"]').val();
        var order_email = $('[name="email"]').val();
        var order_phone = $('[name="phone"]').val();
        var order_address = $('[name="address"]').val();
        var order_address2 = $('[name="address2"]').val();
        var order_city = $('[name="city"]').val();
        var order_state = $('[name="state"]').val();
        var order_zip = $('[name="zip"]').val();
        var order_country = $('[name="country"]').val();
        var get_summary_info1 = $('.grup-prdcts-summary-info1').text();
        var get_summary_info2 = $('.grup-prdcts-summary-info2').text();
    
        var order_summary = get_summary_info1+" | "+get_summary_info2;
    
        var id1=$("#id").val();          
	    var name= window.location.href;                                            
        //alert("order_firstName ="+order_firstName+", order_lastName="+order_lastName);
        var url = script_url+"?callback=ctrlq&firstName="+order_firstName+"&lastName="+order_lastName+"&email="+order_email+"&phone="+order_phone+"&address="+order_address+"&address2="+order_address2+"&city="+order_city+"&state="+order_state+"&zip="+order_zip+"&country="+order_country+"&order_summary="+order_summary+"&id="+id1+"&action=insert";
        document.getElementById("loader").style.display = "block";  
        document.getElementById("loader").style.visibility = "visible";                                                        
    
    
        var request = jQuery.ajax({
          crossDomain: true,
          url: url ,
          method: "GET",
          dataType: "jsonp"                                            
        });    
        return false;
  });
  
}); 

